
<!--<picture class="z-bottom" [class.front]="banneri == 1">
    <source srcset="assets/images/fachada.webp" type="image/webp">
    <source srcset="assets/images/fachada.jpg" type="image/jpeg"> 

    <img #fachada
        src="assets/images/fachada.jpg"
        alt="Fachada Essence Estoril"
        class="banner"
        width="2018px"
        height="1166px"
        (load)="fachada.classList.add('ready');
                shadowTop.classList.add('ready');
                shadowBottom.classList.add('ready')"
        [style.top]="'calc(50% + ' + offsetscroll + 'px)'"
        [style.transform]="fachada.classList.contains('ready') ? 'translate(' + offsetx + '%,' + offsety + '%) scale(1.1)' : ''">
</picture>-->

<video *ngIf="desktop"
        #desktop
        (canplay)="desktop.classList.add('ready'); shadowTop.classList.add('ready'); shadowBottom.classList.add('ready')"
        class="banner front" playsinline autoplay [muted]="'muted'" loop src="assets/videos/banner-desktop.mp4">
</video>

<video *ngIf="!desktop"
        #mobile
        (canplay)="mobile.classList.add('ready'); shadowTop.classList.add('ready'); shadowBottom.classList.add('ready')"
        class="banner front" playsinline autoplay [muted]="'muted'" loop src="assets/videos/banner-mobile.mp4">
</video>

<div class="logo z-top" [style.top]="'calc(2.8rem + ' + offsetscroll + 'px)'"></div>

<h2 [class.dencapsulate]="animate" class="title f-light f-center f-upper z-top"
    [innerHTML]="titleForAnimation"
    [style.bottom]="'calc(19.8rem - ' + offsetscroll + 'px)'"></h2>

<p [class.dencapsulate]="animate" class="text f-light f-center z-top"
    [innerHTML]="textForAnimation"
    [style.bottom]="'calc(15.8rem - ' + offsetscroll + 'px)'"></p>

<img class="scroll z-top"
     src="assets/images/scroll.gif"
     width="213px"
     height="470px"
     [style.bottom]="'calc(7.5rem - ' + offsetscroll + 'px)'">

<div #shadowTop class="shadow-top z-medium"></div>
<div #shadowBottom class="shadow-bottom z-medium"></div>